import { render, staticRenderFns } from "./KasBesarForm.vue?vue&type=template&id=7db7b8c8"
import script from "./KasBesarForm.vue?vue&type=script&lang=js"
export * from "./KasBesarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports